import { Component, OnInit } from '@angular/core';
import { UsersService} from "../users.service";
import { User} from "../user.model";
import { GroupsService} from "../../groups/groups.service";
import {Group} from "../../groups/group.model";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { MessagesService } from "../../../messages.service";

@Component({
    selector: 'app-user-detail',
    templateUrl: './user-detail.component.html',
    styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {

    public loading : boolean;
    public userNotNull : boolean;
    public user: User;
    public groups: Group[];
    public modeEdit: boolean;
    public showResetPassword: boolean;
    public dropdownList = [];
    public selectedItems = [];
    public dropdownSettings = {};
    
    
    
    
    constructor(private usersService: UsersService, private route: ActivatedRoute, private groupsService: GroupsService, private router: Router,private messagesService:MessagesService) { }

    ngOnInit() {
        this.user = new User();
        this.groups = [];
        this.showResetPassword = false;
        const userId: number = this.route.snapshot.params["id"];
        if (userId == null) {
            this.modeEdit = false;
            this.user = new User();
            this.userNotNull = true;
            this.selectedItems = []; 
        } else {
            this.modeEdit = true;
            this.loadUser(userId);
        }
        this.loadGroups();
        this.dropdownSettings = { 
                                  singleSelection: true, 
                                  text:"Seleccione un perfil",
                                  selectAllText:'Seleccionar todas',
                                  unSelectAllText:'Deseleccionar todas',
                                  enableSearchFilter: true,
                                  searchPlaceholderText:"Buscar",
                                };      
    }



    private loadUser(userId: number): void {
        this.loading = true;
        this.usersService.getUser(userId).subscribe(
            data => {
                this.loading = false;
                this.userNotNull = true;
                this.user = data;
                this.selectedItems = this.user.groups.map(g => ({ id: g.groupId, itemName: g.description }));
            },
            error => { this.loading = false; this.checkError(error,"Ha ocurrido un error al cargar el usuario"); }
        );
    }

    private loadGroups(): void {
        this.loading = true;
        this.groupsService.getAllGroups().subscribe(
            data => {
                this.loading = false;
                this.groups = data;
                this.dropdownList = this.groups.map(g => ({ id: g.groupId, itemName: g.description }));
                
            },
            error => { this.loading = false;this.checkError(error,"Ha ocurrido un error al cargar los perfiles"); }
        );
    }

    update(): void {
        this.loading = true;
        let errors = this.validateUser(this.user, this.modeEdit);
        if (errors.length > 0) {
             this.loading = false;
             this.messagesService.viewWarnings(errors);
        } else {
            this.user.groups = this.selectedItems.map(g => new Group(g.id,g.itemName));
            this.usersService.update(this.user).subscribe(
                data => {
                    this.loading = false;
                    this.loadUser(this.user.id);
                },
                error => {
                    this.loading = false;
                    this.checkError(error,"Ha ocurrido un error al actualizar el usuario");
                }
            );

        }
    }

    inactive(user: User) {
        this.loading = true;
        this.usersService.inactive(user.id, user.version).subscribe(
            data => {this.loading = false; this.loadUser(this.user.id)},
            error => { this.loading = false; this.checkError(error,"Ha ocurrido un error al inactivar el usuario"); }
        );
    }

    active(user: User) {
        this.loading = true;
        this.usersService.active(user.id, user.version).subscribe(
            data => {this.loading = false; this.loadUser(this.user.id)},
            error => { this.loading = false; this.checkError(error,"Ha ocurrido un error al activar el usuario"); }
        );
    }

    save() {
        this.loading = true;
        let errors = this.validateUser(this.user, this.modeEdit);
        if (errors.length > 0) {
            this.loading = false;
            this.messagesService.viewWarnings(errors);
        } else {
            this.user.groups = this.selectedItems.map(g => new Group(g.id,g.itemName));
            this.usersService.save(this.user).subscribe(
                data => { this.loading = false; this.router.navigate(['./users']) },
                error => {
                    this.loading = false;
                    this.checkError(error,"Ha ocurrido un error al guardar el usuario");
                }
            );
        }
    }

    resetPassword() {
        this.loading = true;
        let errors = this.validateResetPassword(this.user);
        if (errors.length > 0) {
             this.loading = false;
             this.messagesService.viewWarnings(errors);
        } else {
            this.usersService.resetPassword(this.user).subscribe(
                data => {this.loading = false; this.router.navigate(['./users'])},
                error => {
                    this.loading = false;
                    this.checkError(error,"Ha ocurrido un error al resetear las claves");
                }
            );
        }
    }

    showPassword() {
        this.user.password = null;
        this.user.confirmPassword= null;
        this.showResetPassword = true;
    }
    
     hidePassword() {
        this.user.password = null;
        this.user.confirmPassword= null;
        this.showResetPassword = false;
    }


    private validateUser(pUser: User, editMode: boolean): string[] {
        let errors: string[] = [];
        if (pUser.firstname == null || pUser.firstname.trim().length == 0) {
            errors.push('Debe ingresar el nombre');
        }
        if (pUser.lastname == null || pUser.lastname.trim().length == 0) {
            errors.push('Debe ingresar el apellido');
        }
        if (pUser.username == null || pUser.username.trim().length == 0) {
            errors.push('Debe ingresar el email');
        }
        if (this.selectedItems.length==0) {
            errors.push('Debe seleccionar el perfil');
        }
        if (!editMode) {
            if (pUser.password == null || pUser.password.trim().length == 0) {
                errors.push('Debe ingresar la clave');
            }
            if (pUser.confirmPassword == null || pUser.confirmPassword.trim().length == 0) {
                errors.push('Debe ingresar la confirmacion de la clave');
            }
            if (pUser.password != null && pUser.confirmPassword != null && pUser.password != pUser.confirmPassword) {
                errors.push('Las claves no coinciden');
            }
        }
        return errors;
    }

    private validateResetPassword(pUser: User): string[] {
        let errors: string[] = [];
        if (pUser.password == null || pUser.password.trim().length == 0) {
            errors.push('Debe ingresar la clave');
        }
        if (pUser.confirmPassword == null || pUser.confirmPassword.trim().length == 0) {
            errors.push('Debe ingresar la confirmacion de la clave');
        }
        if (pUser.password != null && pUser.confirmPassword != null && pUser.password != pUser.confirmPassword) {
            errors.push('Las claves no coinciden');
        }
        return errors;
    }

     private checkError(error: any, defaultMessage: string) {
        this.messagesService.checkError(error,defaultMessage);
    }
    


}